import { KITCHEN_COLLECTIONS_CDN_PATH } from 'landings/kitchen-collections/kitchen-collections-constants';

type OrderStepStructure = {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
};

export const ORDER_STEPS_DATA: OrderStepStructure[] = [
  {
    imageSrc: `${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/order-steps/step-1.jpg/step-1.jpg`,
    imageAlt: 'Спроектированная кухня',
    title: 'Выберите коллекцию',
    description:
      'Определитесь с\u00A0внешним видом вашей будущей кухни и\u00A0выберите подходящую коллекцию.',
  },
  {
    imageSrc: `${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/order-steps/step-2.jpg/step-2.jpg`,
    imageAlt: 'Замер кухни',
    title: 'Замерьте свою кухню',
    description: 'Выполните замер самостоятельно или воспользуйтесь услугами наших специалистов.',
  },
  {
    imageSrc: `${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/order-steps/step-3.jpg/step-3.jpg`,
    imageAlt: 'Вычисление параметров кухни',
    title: 'Укажите параметры',
    description:
      'Определитесь с\u00A0формой и\u00A0размером кухни. Добавьте в\u00A0корзину выбранную кухню и\u00A0нужную технику.',
  },
  {
    imageSrc: `${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/order-steps/step-4.jpg/step-4.jpg`,
    imageAlt: 'Оформление заказа кухни',
    title: 'Оформите заказ',
    description: 'Оплатите покупку, и\u00A0мы\u00A0доставим вашу кухню в\u00A0удобное для вас время.',
  },
];
